import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Preview = ({ heading }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div className="bg-[#1e1e1e] text-white p-4 rounded-md border border-green-500">
        <div
          className="flex justify-between items-center cursor-pointer p-3 bg-[#2a2a2a] rounded-md"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <span>{heading}</span>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </div>

        {/* {isExpanded && (
        <div className="mt-2 bg-[#2a2a2a] border border-gray-600 rounded-md p-3">
                  </div>
      )} */}
      </div>
    </>
  );
};

export default Preview;
